"use client";

import Picture1 from "../images/must-experience/bali-tour-package-1.jpg";
import Picture2 from "../images/must-experience/bali-tour-package-2.jpg";
import Picture3 from "../images/must-experience/bali-tour-package-3.jpg";
import Picture4 from "../images/must-experience/bali-tour-package-4.jpg";
import Picture5 from "../images/must-experience/bali-tour-package-6.jpg";
import Picture6 from "../images/must-experience/bali-tour-package-5.jpg";
import Picture7 from "../images/must-experience/bali-tour-package-7.jpg";
import Picture8 from "../images/must-experience/bali-tour-package-8.jpg";
import Picture9 from "../images/must-experience/bali-tour-package-9.jpg";

import Car from "@/public/svg/destinations/hand-picked/car.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import Activity from "@/public/svg/destinations/hand-picked/activity.svg";
import Dot from "@/public/svg/destinations/hand-picked/dot.svg";

import HorizontalTicketCard from "@/components/horizontal-ticket-card/ticket-card";
import TicketCard from "@/components/ticket-card/ticket-card";
import Title from "@/components/title/Title";

import "@/styles/common/swiper.scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss";

import "@/sections/common/horizontal-card/horizontal-card.scss";

const Honeymoon = [

    {
        name: "5N Bali Honeymoon Tour Package from Chennai",
        picture: Picture8,
        location: "3N Kuta | 2N Ubud",
        price: "₹33,999 ",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "12 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Mesmerising Uluwatu Temple Sunset Tour",
            },
            {
                icon: Dot,
                title: "Soak in the Sun at Padang Padang Beach",
            },
            {
                icon: Dot,
                title: "Refresh Your Senses at Tegenungan Waterfall",
            },
            {
                icon: Dot,
                title: "Explore the Clear Waters of Crystal Bay Beach",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "6N Bali Tour Package from Chennai – Tropical Bliss Awaits",
        picture: Picture9,
        location: "3N Kuta | 3N Ubud",
        price: "₹41,999 ",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "15 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Hold On Tight for a Wild Banana Boat Ride",
            },
            {
                icon: Dot,
                title: "Discover the Beauty of North Bali",
            },
            {
                icon: Dot,
                title: "Experience Spiritual Cleansing at Tirta Empul",
            },
            {
                icon: Dot,
                title: "Experience the Excitement of Benoa Water Sports",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "7 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Trending",
                color: "#25d366",
            },
        ],
    },
  
    {
        name: "Best 3N Bali Tour Package from Chennai",
        picture: Picture1,
        location: "2N Kuta | 1N Ubud",
        price: "₹18,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience Thrilling Water Sports at Benoa",
            },
            {
                icon: Dot,
                title: "Explore the Majestic Tegenungan Waterfall",
            },
            {
                icon: Dot,
                title: "Hike Mt. Batur Volcano for a Stunning Sunrise",
            },
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Hassle-Free 4N Bali Tour Package from Chennai",
        picture: Picture5,
        location: "3N Ubud | 1N Kuta",
        price: "₹23,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "10 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Bask in the Serenity of Angel’s Billabong",
            },
            {
                icon: Dot,
                title: "Splash Into Adventure with Ayung River Rafting",
            },
            {
                icon: Dot,
                title: "Hike Bali’s Iconic Mt. Batur Volcano",
            },
            {
                icon: Dot,
                title: "Wander Through Bali’s Scenic Rice Terraces",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Widely Loved",
                color: "#25d366",
            },
        ],
    },
    
    {
        name: "3N Affordable Bali Tour Packages from Chennai",
        picture: Picture2,
        location: "2N Kuta | 1N Seminyak",
        price: "₹16,499",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Discover the Majestic Tanah Lot Temple",
            },
            {
                icon: Dot,
                title: "Escape to Nusa Penida Island",
            },
            {
                icon: Dot,
                title: "Walk Through the Majestic Handara Gate",
            },
            
            
            
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
    {
        name: "4N Magical Bali Tour Package from Chennai",
        picture: Picture7,
        location: "2N Kuta | 1N Ubud | 1N Seminyak",
        price: "₹45,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "5 Star Hotels",
            },
            {
                icon: Activity,
                title: "10 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Experience Bali’s Batik Heritage at Tohpati Village",
            },
            {
                icon: Dot,
                title: "Fly High with Your Partner on the Couple Bali Swing",
            },
            {
                icon: Dot,
                title: "Adventure Awaits in West Nusa Penida",
            },
            {
                icon: Dot,
                title: "Unveil the Mystical Charm of Tanah Lot Temple",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Top Choice",
                color: "#25d366",
            },
        ],
    },
    {
        name: "3N Romantic Bali Tour Package from Chennai",
        picture: Picture3,
        location: "1N Kuta | 2N Ubud",
        price: "₹18,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Wander Through Bali’s Iconic Rice Terraces",
            },
            {
                icon: Dot,
                title: "Discover the Serenity of Ulun Danu Temple",
            },
            {
                icon: Dot,
                title: "A Journey Through Bali’s Coffee Plantations",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Best-Selling",
                color: "#25d366",
            },
        ],
    },
   
    {
        name: "3N Luxury Bali Tour Package from Chennai",
        picture: Picture4,
        location: "3N Kuta",
        price: "₹39,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "5 Star Hotels",
            },
            {
                icon: Activity,
                title: "6 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Relax and Unwind at Padang Padang Beach",
            },
            {
                icon: Dot,
                title: "Discover the Magic of Nusa Penida Island",
            },
            {
                icon: Dot,
                title: "Explore Bali’s Iconic Broken Beach",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
    
    {
        name: "Best 4N Bali Tour Package from Chennai",
        picture: Picture6,
        location: "2N Kuta | 2N Ubud",
        price: "₹29,999",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "4 Star Hotels",
            },
            {
                icon: Activity,
                title: "9 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Feel the Rush with Ayung River Rafting",
            },
            {
                icon: Dot,
                title: "Unveil the Beauty of Kelingking Beach",
            },
            {
                icon: Dot,
                title: "Relax and Unwind at Bali’s Pandawa Beach",
            },
            {
                icon: Dot,
                title: "Capture the Perfect Sunset at Uluwatu Temple",
            },
            
           
            
            
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
   
    
   

];

const HorizontalCard = () => {
    return (
        <section className="horizontal-card-section py-10 md:py-20">
            <div className="horizontal-card-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Top Bali Tour Packages from Chennai" />
                <div className="horizontal-card-wrapper flex flex-col gap-14">
                    {Honeymoon.map((h, index) => {
                        return <HorizontalTicketCard key={index} {...h} />;
                    })}
                </div>
            </div>
        </section>
    );
};

export default HorizontalCard;
